import { ApiService, type PaginatedResponse } from '../../../types/api';
import type { PaginationOptions } from '../../../utils/pagination';
import type { CompanyListQuery, CompanyLookup, CompanyRequest } from '../types/api';
import type { Company, CompanyDetail } from '../types/company';
import { CompanyApi, type CompanyApiContract } from './company.api';

export interface CompaniesApiContract {
  list(query: CompanyListQuery, pagination: PaginationOptions): Promise<PaginatedResponse<Company>>;
  create(payload: CompanyRequest): Promise<CompanyDetail>;
  company(lookup: CompanyLookup): CompanyApiContract;
}

declare module '../../../context/page-context' {
  interface Apis {
    companies: CompaniesApiContract;
  }
}

/**
 * A service to interact with companies via the SparkLayer API.
 */
export class CompaniesApi extends ApiService implements CompaniesApiContract {
  public list(
    query: CompanyListQuery,
    pagination: PaginationOptions,
  ): Promise<PaginatedResponse<Company>> {
    const params = pagination.toQueryParams();
    if (query.search_term) {
      params.set('search_term', query.search_term);
    }

    return this.api.proxy({
      method: 'GET',
      path: `/v2/companies?${params}`,
    });
  }

  public create(payload: CompanyRequest): Promise<CompanyDetail> {
    return this.api.proxy({
      method: 'POST',
      path: `/v2/companies`,
      payload,
    });
  }

  public company(lookup: CompanyLookup): CompanyApiContract {
    return new CompanyApi(this.api, lookup);
  }
}
